module.exports = __webpack_public_path__ + "img/bg2.a11cdd40.jpg";